var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ExcelImport',{on:{"onDataImported":_vm.onDataImported}}),_c('PreviewList',{ref:"preview-student-dialog",on:{"onSave":_vm.onSave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }